import React from 'react';
import clsx from 'clsx';

import './panel.scss';
import './layout.scss';

export const Panel = ({ children, title }) => {
  return (
    <div className={clsx('panel-wrapper', !title && 'no-title-panel-wrapper')}>
      <div className='panel'>
        {title && (
          <div className='panel-header'>
            <h5>{title}</h5>
          </div>
        )}
        <div className='panel-body'>
          <div className='panel-inner-body'>{children}</div>
        </div>
      </div>
    </div>
  );
};

export const Row = ({children, wrapReverse, className}) => {
  return (
    <div className={clsx('row', wrapReverse && 'wrap-reverse', className)}>
      {children}
    </div>
  )
}

export const Col = ({children, width, style, className}) => {
  const colWidthSet = [25, 75, 100];

  return (
    <div className={clsx('custom-column', colWidthSet.includes(width) && `col-${width}`, className)} style={style}>
      {children}
    </div>
  )
}